import { render, staticRenderFns } from "./add-customization.vue?vue&type=template&id=327acb92&"
import script from "./add-customization.vue?vue&type=script&lang=js&"
export * from "./add-customization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports